<template>
<div>
    <modal :show.sync="modal_success">

            <p>{{$t('success_confirm')}}</p>

            <template slot="footer">
                <base-button @click="modal_success = false, goLogin()" type="primary">{{$t('login')}}</base-button>
            </template>

        </modal>


        <modal :show.sync="modal"
               :gradient="modal_setting.gradient"
               modal-classes="modal-danger modal-dialog-centered">
            <div class="py-3 text-center">
                <i class="ni ni-bell-55 ni-3x"></i>
                <h4 class="heading mt-4"></h4>
                <p>{{modal_setting.alert_text}}</p>
            </div>

            <template slot="footer">
                <base-button type="link"
                             text-color="white"
                             class="ml-auto"
                             @click="modal = false">
                    {{$t('close')}}
                </base-button>
            </template>
        </modal>
</div>
</template>

<script>
import i18n from "@/i18n"
export default {
  name: 'Verify',
  data() {
      return {
        email_code: this.$route.query.token,
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        modal_success: false,
      }
  },
  created () {
    this.onSubmit()
  },
  methods: {
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        onSubmit () {
            this.$http.post('profile/confirmEmail', {
                "email_code": this.email_code
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.modal_success = true
            // this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/login')
        },
        onSubmitFailed (req) {
            this.modalAlert(req)
            // this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/login')
        },
        goLogin () {
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/login')
        }
  }
}
</script>
